import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_CATEGORY_FAILURE,
  CREATE_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_SUCCESS,
  GET_ALL_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_BANNER_REQUEST,
  CREATE_CATEGORY_BANNER_FAILURE,
  UPDATE_CATEGORY_BANNER_REQUEST,
  UPDATE_CATEGORY_BANNER_FAILURE,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllCategory = () => async (dispatch) => {
  dispatch({ type: GET_ALL_CATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/categories`);
    dispatch({ type: GET_ALL_CATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_CATEGORY_FAILURE, payload: error.message });
  }
};

export const createCategory = (categoryData, formData) => async (dispatch) => {
  dispatch({ type: CREATE_CATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/category`, categoryData);
    if (data) {
      const { res } = await privateAxios.put(
        `admin/category/${data.id}/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      dispatch(getAllCategory());
      toast.success("Category Created Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_CATEGORY_FAILURE, payload: error.message });
  }
};


export const updateCategory = (categoryId, categoryData, formData) => async (dispatch) => {
  dispatch({ type: UPDATE_CATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/category/${categoryId}`,
      categoryData
    );
    if (data.status === "SUCCESS") {
      if (formData && formData.get("imageFile") && formData.get("imageFile").name) {
        const { res } = await privateAxios.put(
          `admin/category/${categoryId}/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
      }
      dispatch(getAllCategory());
      toast.success("Category Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_CATEGORY_FAILURE, payload: error.message });
  }
};

export const deleteCategory = (categoryId) => async (dispatch) => {
  dispatch({ type: DELETE_CATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/category/${categoryId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_CATEGORY_SUCCESS, payload: categoryId })
      dispatch(getAllCategory());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_CATEGORY_FAILURE, payload: error.message });
  }
};

export const createCategoryBanner = (categoryBannerData, formData) => async (dispatch) => {
  dispatch({ type: CREATE_CATEGORY_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/categoryBanner`, categoryBannerData);
    if (data) {
      const { res } = await privateAxios.put(
        `admin/categoryBanner/${data.id}/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      dispatch(getAllCategory());
      toast.success("Category Banner Upload Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_CATEGORY_BANNER_FAILURE, payload: error.message });
  }
};


export const updateCategoryBanner = (categoryBannerId, categoryBannerData, formData) => async (dispatch) => {
  dispatch({ type: UPDATE_CATEGORY_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/categoryBanner/${categoryBannerId}`,
      categoryBannerData
    );
    if (data.status === "SUCCESS") {
      if (formData && formData.get("imageFile") && formData.get("imageFile").name) {
        const { res } = await privateAxios.put(
          `admin/categoryBanner/${categoryBannerId}/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
      }
      dispatch(getAllCategory());
      toast.success("Category Banner Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_CATEGORY_BANNER_FAILURE, payload: error.message });
  }
};
